import { Component, HostBinding, inject, input } from "@angular/core";
import { MutexService } from "common/concurrency/mutex.service";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { ResetTailoringService } from "process/tailoring/reset/reset-tailoring.service";
import { TranslateModule } from "@ngx-translate/core";

import { SpinComponent } from "common/spin/spin.component";

@Component({
	selector: "stages-reset-dialog",
	templateUrl: "./reset-dialog.component.html",
	imports: [TranslateModule, SpinComponent],
})
export class ResetDialogComponent {
	private dialog = inject(DialogAdapter);
	private resetTailoringService = inject(ResetTailoringService);
	private mutexService = inject(MutexService);

	@HostBinding("class.autoHeight") dialogAutoHeightClass = true;

	readonly workspaceId = input.required<string>();

	readonly pv = input.required<string>();

	resetInProgress = false;

	reset(): void {
		this.mutexService.invoke(`resetTailoring${this.workspaceId()}`, async () => {
			this.resetInProgress = true;
			await this.resetTailoringService.reset(this.workspaceId(), this.pv());
			this.resetInProgress = false;
			this.close();
		});
	}

	close(): void {
		this.dialog.close(undefined);
	}
}
